var _style, _g, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNopocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 423 520",
    style: {
      enableBackground: "new 0 0 423 520"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st87{fill:none;stroke:#010101;stroke-width:2;stroke-miterlimit:10;}\n\t.st86{fill:#FFFFFF;stroke:#010101;stroke-width:0.75;stroke-miterlimit:10;stroke-dasharray:3;}\n\t.st85{fill:#FFFFFF;stroke:#010101;stroke-width:2;stroke-miterlimit:10;}\n\t.st84{fill:#010101;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M350.87,158.58v198.28c0,24.14-19.58,43.72-43.72,43.72H125.59c-24.14,0-43.72-19.58-43.72-43.72V158.58 H350.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M125.59,397.58c-22.45,0-40.72-18.27-40.72-40.72V161.58h263v195.28c0,22.45-18.27,40.72-40.72,40.72H125.59z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.87,
    y: 106.58,
    className: "st85",
    width: 269,
    height: 52
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.87,
    y: 109.58,
    className: "st86",
    width: 263,
    height: 46
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -22.07,
    y: 256.31,
    transform: "matrix(0.778 0.6283 -0.6283 0.778 211.6647 -74.6843)",
    className: "st84",
    width: 467.14,
    height: 11.66
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -22.07,
    y: 256.31,
    transform: "matrix(-0.778 0.6283 -0.6283 -0.778 540.7408 333.1732)",
    className: "st84",
    width: 467.14,
    height: 11.66
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNopocket);
export default __webpack_public_path__ + "static/media/NO POCKET.809b796874f74b03703c64a618a60250.svg";
export { ForwardRef as ReactComponent };